import { render, staticRenderFns } from "./PropertyFormAdditional.vue?vue&type=template&id=1c49b47c&scoped=true&"
import script from "./PropertyFormAdditional.vue?vue&type=script&lang=ts&"
export * from "./PropertyFormAdditional.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyFormAdditional.vue?vue&type=style&index=0&id=1c49b47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49b47c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
